import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SIGN_IN_URL } from '../../constants/AppUrlConstants';
import Auth from '../Auth';

const ProtectedRoutes = () => {
  const location = useLocation();
  const isAuthenticated = !!Auth.isAuthorized();
  return (
    (isAuthenticated) ? <Outlet /> : <Navigate to={SIGN_IN_URL} state={{ redirectURL: location }} replace />
  );
};

export default ProtectedRoutes;
